import React from 'react';
import './LoanAgainstProperty.css';
import 'animate.css/animate.min.css';
import Seo from "../components/Seo";









function LoanAgainstProperty() {
  return (
    <>
  
    <Seo
        title="Loan Against Property in Pune – Low Interest Rates | Mortbuzz"
        description="Get the best Loan Against Property in Pune with Mortbuzz. Enjoy low interest rates, high loan amounts, and easy approvals for salaried and self-employed professionals."
        keywords="Loan Against Property in Pune, LAP interest rates, best loan against property consultant, mortgage loan in Pune, apply LAP online"
        canonical="https://www.mortbuzz.in/mortbuzz-loan-against-property"
      />


    {/* Meta tags (use react-helmet if needed) */}
      {/* Hero Section */}
      <section className="mortbuzzhheroLoanA position-relative d-flex flex-column justify-content-center">
        <div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
        <div className="container">
          <h1 className="animate__animated animate__fadeInDown">Unlock the Power of Your Loan Against Property in Pune with MortBuzz</h1>
          <p className="lead animate__animated animate__fadeInUp animate__delay-1s">Find the best Loan Against Property tailored for you.</p>
          <a href="apply-now" className="apply-btn-glass mt-4 animate__animated animate__fadeInUp animate__delay-2s">Apply Now</a>
        </div>
      </section>



{/*<!-- About Home Loan -->*/}
<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
                <img src="/images/FrontPage/Balance transfer.jpg" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
            <div className="col-lg-6 text-white">
                <h2 className="mb-4 text-white ">Why Choose MortBuzz for Your Loan Against Property in Pune?</h2>
                <p>A loan against property is a secured loan you can take by pledging your residential property, we are best lap provider in pune, or a plot of land as collateral. With such a loan, you can secure a loan amount of up to a certain percentage of your property’s value. Lenders also offer low processing fees and affordable low interest loan against property on LAP loan. The best part? These loans can be used freely, without specifying the end-use to the lender. This means they can easily cover all your expenses – education costs, home renovation, vacations, and more.Like most other loans, finding the best loan against property deal starts with choosing the right lender.</p>
                <ul class="list-unstyled mt-3">
                    <li>✅ Low Interest loan against property 8.80%*</li>
                    <li>✅ Your Property’s Power, Your Financial Freedom.</li>
                    <li>✅ From Bricks to Benefits – Instant LAP Solutions.</li>
                    <li>✅ Transparent Loans. Trusted Support. Timely Funds</li>
                    <li>✅ Funding Upto 85%</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ mortgage loan in pune</li>
                </ul>
            </div>
        </div>
    </div>
</section>






{/*<!-- Loan Uses -->*/}
<section className="section bg-light">
    <div className="container text-center">
        <h2 className="mb-5">Uses of a Loan Against Property in Pune</h2>
        <div className="row g-4">
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>Home renovation</h5>
                    <p>The place you’ve always called home needs an upgrade now and then. Give your house a face-lift with an easy home loan against property. This loan covers all your home remodelling costs, from a kitchen upgrade to balcony extension, without leaving a hole in your pocket.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-1s">
                    <h5>Education</h5>
                    <p>Higher education often requires a substantial amount of funds. Using up your savings to pursue education is not a financially wise move. Use a loan against property to manage your costs of tuition and living easily. Enjoy affordable interest rates and quick approvals with a variety of lenders.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Business expansion</h5>
                    <p>If you’re planning to expand your business, you need adequate capital to pay for expenses like utilities, rent, salaries, and more. A loan against property can help you easily cover these costs. These secured loans are available on competitive interest rates and easy terms. Scale your business with feature-rich loans offered by several lenders.</p>
                </div>
            </div>

<div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Buying property</h5>
                    <p>Some homeowners choose this route for buying a home when they are not able to get a home loan for buying additional property. You can pledge either commercial or residential property to avail a loan against property for this purpose.</p>
                </div>
            </div>
<div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Wedding</h5>
                    <p>When you’re planning your dream wedding, you only want the best. Before you know it, wedding costs pile up quickly. Thankfully, a loan against property can take care of all the costs associated with your big day. Be it a grand venue or the best makeup artist, fund all your expenses with a loan against property.</p>
                </div>
            </div>
<div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Travel </h5>
                    <p>Don’t wait to save up enough before you can finance your next vacation. Get a loan against property to pay for all travel expenses, big or small. Jet off to exotic foreign lands you’ve always wanted to visit with an easy loan against property.</p>
                </div>
            </div>
        </div>
    </div>
</section>
    
    
  {/*<!-- Eligibility Criteria -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Loan Against Property Pune Eligibility Criteria</h2>
        <div className="row text-center">
            {/* CARD 1 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/salaried-image-icon.png" 
                        alt="Eligibility" 
                        style={{ width: '200px', height: '200px' }}
                        className="mb-3"
                    />
                    <p className="text-center">Salaried/Working Professional</p>
                </div>
            </div>
            {/* CARD 2 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/age.png" 
                        alt="Age" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3" 
                    />
                    <p className="text-center">Age: 21-60 Years</p>
                </div>
            </div>
            {/* CARD 3 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/3-month-experienced.png" 
                        alt="Experience" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a job and a minimum of<br />3 months experience</p>
                </div>
            </div>
            {/* CARD 4 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/minimum-income_20000.png" 
                        alt="Income" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Having a minimum of Rs. 25,000<br />net income per month.</p>
                </div>
            </div>
        </div>
    </div>
</section>

    
    {/*<!-- Apply Section -->*/}
<section id="apply" className="section bg-light text-center">
    <div className="container">
        <h2 className="mb-4">Ready to Start Your Journey?</h2>
        <p>Apply now and let MortBuzz Solutions Advisory guide you to the best Loan Against Property options.</p>
        <a href="apply-now" className="apply-btn-glass btn-lg mt-3">Apply for Home Loan</a>
    </div>
</section>
    
{/*<!-- Documentation Required Section -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Documentation Required</h2>
        <div className="row g-5">

            {/*<!-- Photo Identity Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        
                        <img src="/images/Bank Pages/photo-identy.png" alt="Photo-ID" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Photo Identity Proof</h5>
                    </div>
                    <ul className= "text-white">
                        <li>Voter ID</li>
                        <li>Aadhaar Card</li>
                        <li>Passport</li>
                        <li>PAN Card</li>
                        <li>Driving Licence</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Proof of Residence -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/proof-of-residence.png" alt="Address Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 class="mb-0 text-white">Proof of Residence</h5>
                    </div>
                    <ul class="text-white">
                        <li>Aadhaar Card</li>
                        <li>Driving Licence</li>
                        <li>Passport</li>
                        <li>Registered Rent Agreement</li>
                        <li>Latest Gas/Electricity Bill</li>
                        <li>Bank Statement with Current Address</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Income Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/income-proof.png" alt="Income Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Income Proof</h5>
                    </div>
                    <ul className="text-white">
                        <li>Income Tax Returns (Last 3 Years)</li>
                        <li>Business License Details</li>
                        <li>Audited Balance Sheet & Profit/Loss (Last 3 Years)</li>
                        <li>Business Address Proof</li>
                        <li>6-Month Bank Statements (Current & Savings)</li>
                        <li>Copy of Form 16</li>
                        <li>6-Month Salary Account Statements</li>
                        <li>Last 3 Months’ Salary Slips</li>
                    </ul>
                </div>
            </div>

            {/*<!-- Other Documents -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/other-document.png" alt="Other Documents" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Other Documents</h5>
                    </div>
                    <ul className="text-white" >
                        <li>Allotment Letter</li>
                        <li>Sale Deed</li>
                        <li>No Objection Certificate (NOC)</li>
                        <li>Allotment Letter from Society/Housing Board/Builder</li>
                        <li>Stamped Agreement of Sale</li>
                        <li>Possession Certificate</li>
                        <li>Construction Cost Estimate</li>
                        <li>Bank Payment Statement</li>
                        <li>Occupancy Certificate</li>
                        <li>Land Tax Receipt</li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>    

{/*<!-- Application Process Section -->*/}
<section className="section bg-dark text-white py-5">
    <div className="container">
      <h2 className="text-center mb-5 text-white">Application Process</h2>
  
      <div className="timeline">
        {/*<!-- Step 1 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 1: Connect with Us</h4>
            <p>Explain your needs. We curate loan products most suitable for your profile.</p>
          </div>
        </div>
  
        {/*<!-- Step 2 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 2: Compare Loan Products</h4>
            <p>We help you compare several home loan products so you can choose the best one.</p>
          </div>
        </div>
  
       {/* <!-- Step 3 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 3: Apply Online</h4>
            <p>Pick a lender, apply online, and submit all necessary paperwork with our assistance.</p>
          </div>
        </div>
  
       {/* <!-- Step 4 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 4: Application Processing</h4>
            <p>The lender verifies your documentation and processes the application.</p>
          </div>
        </div>
  
        {/*<!-- Step 5 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 5: Receive Funds</h4>
            <p>Upon approval, the loan amount is credited directly to your account.</p>
          </div>
        </div>
  
      </div>
    </div>
  </section>

{/* <!-- Home Loan Rates Section -->*/}
<section className="section bg-light py-5">
    <div className="container">
      <h2 className="text-center mb-5">Low interest Loan Against Property In Pune Rate</h2>
  
      <div className="table-responsive">
        <table className="table table-hover table-striped shadow-lg rounded">
          <thead className="table-primary">
            <tr>
              <th>Bank Name</th>
              <th>Min. Rate of Interest (%)</th>
              <th>Loan Amount</th>
              <th>Loan Tenure</th>
              <th>Processing Fees</th>
              <th>Apply Now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><a href="https://www.idfcfirstbank.com/personal-banking/loans/loan-against-property/lap-interest-rate">IDFC FIRST Bank</a></td>
              <td>9.50%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>5 years - 25 years</td>
              <td>3%</td>
              <td><a href="apply-noww" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://campaigns.icicibank.com/hl/loanAgainstProperty/main/index.html">ICICI Bank </a></td>
              <td>11.10%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>2.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://bankofindia.co.in/star-loan-against-property">Bank Of india</a></td>
              <td>9.10%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>1%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.centralbankofindia.co.in/en/Cent_Mortgage_msme">Central Bank Of India</a></td>
              <td>9.50%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>5 years - 25 years</td>
              <td>1.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://bankofmaharashtra.in/loan-against-property">Bank Of Maharashtra</a></td>
              <td>9.95%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>5 years - 25 years</td>
              <td>1%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.axisbank.com/retail/loans/loan-against-property">Axis Bank</a></td>
              <td>9.25%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>1%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.hdfcbank.com/personal/borrow/your-loans-against-securities/loan-against-property">HDFC LTD</a></td>
              <td>11.80%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>0.50% or Rs. 3000</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.kotak.com/en/business/loans/loan-against-property.html">Kotak Mahindra Bank</a></td>
              <td>9.50%</td>
              <td>Rs. 10 LAKHS - 10CR</td>
              <td>5 years - 25 years</td>
              <td>1%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.idbibank.in/loan-against-property.aspx">IDBI Bank</a></td>
              <td>9.50%</td>
              <td>Rs. 10 LAKHS - 25CR</td>
              <td>5 years - 25 years</td>
              <td>1%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </div>
  </section>



<section className="section py-5 bg-dark">
    <div className="container">
      <div class="row align-items-center g-5">
       {/* <!-- Image Section -->*/}
        <div className="col-md-6 text-center">
          <img src="/images/FrontPage/loan-dealing.jpg" alt="Processing Fee" className="img-fluid rounded shadow"/>
        </div>
  
       {/* <!-- Content Section -->*/}
        <div className="col-md-6">
          <h2 className="mb-4 text-primary" style={{fontWeight: '700'}}>Processing Fee</h2>
          <p style={{fontSize: '17px', color: '#FFEDFA'}}>
            Besides the Loan Against Property in pune interest rate, you also need to pay a processing fee to your lender. This charge helps lenders cover the cost of verifying your documentation and processing your loan application.
          </p>
          <p style={{fontSize: '17px', color: '#FBFBFB'}}>
            Typically, the processing fee ranges between 0.5% to 2% of your total loan amount. Additionally, a GST of 18% is applicable on the fee.
          </p>
          <p style={{fontSize: '17px', color: '#FBFBFB'}}>
            At MortBuzz Solutions Advisory, we help you find lenders who offer the low interest Loan Against Property for processing fees — ensuring you save more from the start.
          </p>
          
          <a href="apply-now" className="apply-btn-glass mt-3">Get Best Offers</a>
        </div>
      </div>
    </div>
  </section>



 {/* <!-- mortbuzz Additionally adding Text Box Section -->*/}

<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            
            <div className="col-lg-6">
                <h2 className="mb-4 text-primary">MortBuzz Solutions Home Loan Balance Transfer</h2>
                <p className="text-white">If you’ve been paying hefty home loan EMIs and want to reduce your financial burden, consider a home loan balance transfer. A home loan balance transfer, or home loan refinancing, is a method of transferring your outstanding home loan balance from your existing lender to a new one. Yes, there are several benefits of home loan balance transfer. This facility can help you enjoy lower interest rates and better repayment terms. You can also get a top-up loan during the home loan balance transfer process if you need some extra cash.</p>
                <ul class="list-unstyled mt-3 text-white">
                    <li>✅ Lowest Interest Rates 8.80%*</li>
                    <li>✅ Big Needs? Your Property Has the Answer.</li>
                    <li>✅ Safe, Secured, and Smart – That’s LAP with Mortbuzz.</li>
                    <li>✅ Fast Loan Processing</li>
                    <li>✅ 100% Cashback on Charges</li>
                    <li>✅ Doorstep Service</li>
                    <li>✅ Fast Loan Processing</li>
                </ul>
            </div>

            <div className="col-lg-6 mb-4">
            <img src="/images/Bank Pages/luxuryhome.png" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
        </div>
    </div>
</section>

{/*<!-- mortbuzz Additionally adding Text Box Section End -->*/}




 {/*<!-- FAQ Section -->*/}
<div className="w-100 px-3 px-md-5 py-5 bg-black text-white w-100 bg-black">
  <h2 className="text-center mb-5 display-4 fw-bold text-primary">Frequently Asked Questions</h2>

  <div className="row justify-content-center">
    <div className="col-lg-10 col-md-12">
      <div className="accordion" id="faqAccordion">

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
              <i class="bi bi-question-circle me-3 text-primary fs-4"></i>
              What is MortBuzz Home Loans and how can I apply for a loan?
            </button>
          </h2>
          <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              MortBuzz offers convenient home loans from top banks. Apply online at 
              <a href="/" className="text-primary text-decoration-none">mortbuzz.in</a>. 
              We handle everything—no bank visit needed.
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
              <i className="bi bi-percent me-3 text-primary fs-4"></i>
              What is the interest rate on the home loan?
            </button>
          </h2>
          <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              The current interest rate is <strong className="text-success">8.10%</strong>. One of the most competitive in the market. 
              <a href="https://mortbuzz.in" className="text-primary text-decoration-none">Check your eligibility</a> now.
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
              <i className="bi bi-cash-coin me-3 text-primary fs-4"></i>
              How does the cashback offer work?
            </button>
          </h2>
          <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Cashback depends on your loan amount:
              <ul className="mt-2">
                <li><strong>Above ₹1 Cr:</strong> 100% cashback on fees.</li>
                <li><strong>₹90 Lakh:</strong> 90% cashback.</li>
                <li><strong>₹20 Lakh:</strong> 20% cashback.</li>
              </ul>
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the process for obtaining a home loan from MortBuzz?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Apply at <a href="apply-now" className="text-primary">mortbuzz.in</a>.</li>
                <li>Our team will collect your documents.</li>
                <li>We handle approval with banks.</li>
                <li>Door-to-door service with no bank visits.</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>

         {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq5">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              ✅ What is a Loan Against Property (LAP)?
            </button>
          </h2>
          <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              A Loan Against Property is a secured loan where you mortgage your residential, commercial, or industrial property to borrow funds for business, education, wedding, medical, or personal needs.
            </div>
          </div>
        </div>

       {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq6">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
             🏠 What type of properties can be mortgaged?
            </button>
          </h2>
          <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Self-occupied residential property</li>
                <li>Rented residential property</li>
                <li>Commercial property</li>
                <li>Vacant land with proper ownership documents</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>



     {/*  <!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq7">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              💰 How much loan amount can I get?
            </button>
          </h2>
          <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
                  Loan amount usually ranges from ₹5 Lakhs to ₹10 Crores, depending on:
              <ol>
                <li>Property value (up to 70% of market value)</li>
                <li>Your income and repayment ability</li>
                <li>Credit score and financial history</li>
                <li>Door-to-door service with no bank visits.</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>



      {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq8">
              <i class="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              📄 What documents are required?
            </button>
          </h2>
          <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Here’s what you typically need:
              <ol>
                <li>Identity & address proof (PAN, Aadhaar)</li>
                <li>Income proof (ITR, salary slips, P&L statement)</li>
                <li>Property papers (ownership, title deed, NOC).</li>
                <li>Bank statements (last 6–12 months).</li>
               
              </ol>
            </div>
          </div>
        </div>




   {/*  <!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq9">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
             🕒 How long does it take to get LAP approved?
            </button>
          </h2>
          <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Loan Against Property with MortBuzz can be approved within 3–5 working days if documents and property verifications are completed smoothly.
            </div>
          </div>
        </div>



 {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq10">
              <i class="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              🏷️ What is the interest rate for LAP?
            </button>
          </h2>
          <div id="faq10" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
             Interest rates generally start from 9.5% p.a., depending on
              <ol>
                <li>Loan tenure</li>
                <li>Type of property</li>
                <li>Your credit profile</li>
               
              </ol>
MortBuzz helps you compare offers from multiple banks to get the best rate.
            </div>
          </div>
        </div>



   {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq11">
              <i class="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              🧾 Can I continue to live/use the property after mortgaging it?
            </button>
          </h2>
          <div id="faq11" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              Yes. You retain ownership and full usage rights of the property during the loan tenure, as long as you repay on time.
            </div>
          </div>
        </div>


   {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i class="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the process for obtaining a home loan from MortBuzz?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Apply at <a href="https://mortbuzz.in" class="text-primary">mortbuzz.in</a>.</li>
                <li>Our team will collect your documents.</li>
                <li>We handle approval with banks.</li>
                <li>Door-to-door service with no bank visits.</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>




      </div>
    </div>
  </div>
</div>


    </>
  );
}

export default LoanAgainstProperty;